import logo from "assets/img/logo.svg";
import AuthPage from "components/shared/AuthPage";
import NavigationBar from "components/shared/NavigationBar/NavigationBar";
import { Link } from "react-router-dom";

const Titles = () => {
    return (
        <AuthPage userAuthenticated={true}>
            <div className="App">
                <header className="App-header">
                    <img src={logo} className="App-logo" alt="logo" />
                    <p>Help</p>
                    <Link to="/main">Link to Main</Link>
                </header>
            </div>
        </AuthPage>
    );
};

export default Titles;
